import { useState } from 'react'
import { Modal } from '@mui/material'
import styles from './Ai.module.scss'
import Heading, { EHeadingType } from '../Heading/Heading'
import aiIntro from '@/assets/images/ai/ai-intro.jpg'
import aiSelf from '@/assets/images/ai/ai-pastself.jpg'

const aiIntroVideoId = 'ApKA7eOM8bA'
const aiSelfVideoId = 'y8-jMskj-9w'

export default function Ai() {
  const [openModal, setOpenModal] = useState(false)
  const [currentVideoId, setCurrentVideoId] = useState('')

  const handleOpenModal = (videoId: string) => {
    setCurrentVideoId(videoId)
    setOpenModal(true)
  }

  const handleCloseModal = () => setOpenModal(false)

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <Heading type={EHeadingType.h2} text="Lazy AI" subtext="Leverage AI anywhere on desktop"></Heading>
        <div className={`container payment ${styles.content_container}`}>
          <div>
            <div className={styles.relative_wrapper}>
              <div className={styles.plan_container}>
                <img src={aiIntro.src} alt="Lazy AI" onClick={() => handleOpenModal(aiIntroVideoId)} />
              </div>
            </div>
          </div>
        </div>
        <Heading
          type={EHeadingType.h2}
          text="Chat with your past self"
          subtext="A thinking partner grounded in your own knowledge"
        ></Heading>
        <div className={`container payment ${styles.content_container} ${styles.no_margin}`}>
          <div>
            <div className={styles.relative_wrapper}>
              <div className={styles.plan_container}>
                <img src={aiSelf.src} alt="Lazy AI" onClick={() => handleOpenModal(aiSelfVideoId)} />
              </div>
            </div>
          </div>
        </div>

        {/* YouTube Video Modal */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="video-modal"
          aria-describedby="lazy-ai-video"
        >
          <div className={styles.modal_content}>
            <div className={styles.video_wrapper}>
              <iframe
                className={styles.video_iframe}
                src={`https://www.youtube.com/embed/${currentVideoId}?autoplay=1`}
                title="Lazy AI Video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </Modal>
      </div>
    </section>
  )
}
